import axios from "axios";
import jwtDecode from "jwt-decode";



const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
  headers: {
    Accept: "application/json",
    "Authorization": "Basic T0F1dGgyV2ViVXNlcjpzZWNyZXQ=",
  },
});


api.interceptors.request.use(

  (config) => {
    const { accessToken } = localStorage;
    const selectedShopCode = localStorage.getItem("selectedShopCode") || undefined;
    const securityPassword = localStorage.getItem("X-security-password") || undefined;
    console.table([selectedShopCode, securityPassword]);
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
      config.headers["X-LICENCE-CODE"] = selectedShopCode
      config.headers["X-security-password"]= securityPassword 
    }
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => {
    return Promise.resolve(response)
  },
  (err) => {

    return new Promise((resolve, reject) => {

      const originalReq = err.config;
      console.log("errrrrrrrrrrrrrrrrrrrr", err);
      // if (
      //   err.response &&
      //   err.response.status === 401 &&
      //   err.config &&
      //   !err.config.__isRetryRequest
      // ) 
      if (false) {

        // localStorage.removeItem("accessToken")
        // window.location.reload();
        const decodedToken =
          localStorage.getItem("accessToken") &&
          jwtDecode(localStorage.getItem("accessToken"));
        if (!decodedToken) {
          reject("no token provided");
        }
        // a tester decodedToken.exp chnia el informatino elli fiha 
        // console.log("decodedToken Date.now()", Date.now());
        // console.log("decodedToken" , decodedToken.exp*1000);
        // console.log("Date.now() > decodedToken.exp * 1000", Date.now() > decodedToken.exp * 1000);
        if (Date.now() > decodedToken.exp * 1000) {
          // if(true){
          originalReq._retry = true;
          let res = fetch(
            `${process.env.REACT_APP_API_URL}/uaa/oauth/token`,
            {
              method: "POST",
              mode: "cors",
              cache: "no-cache",
              credentials: "same-origin",
              headers: {
                "Content-Type": "application/json",
                Device: "device",
                Accept: "application/json",
                "Authorization": "Basic T0F1dGgyV2ViVXNlcjpzZWNyZXQ=",
              },
              redirect: "follow",
              referrer: "no-referrer",
              body: JSON.stringify({
                refreshToken: localStorage.getItem("refresh_token"),
                grantType: "refresh_token"
              }),
            },
          )
            .then((res) => res.json())
            .then((res) => {
              console.log(res);
              console.log("/uaa/oauth/token is ", res);
              localStorage.setItem("accessToken", res.access_token);
              localStorage.setItem("refreshToken", res.refreshToken);
              originalReq.headers.Authorization = `Bearer ${res.access_token}`;
              originalReq.headers["Device"] = "device";

              return axios(originalReq);
            })

          resolve(res);
        }
      }
      console.log('err.response ', err.response)
      reject(err.response);
    })


  },
);


export default api;

